import { useEffect } from 'react';
import './MovingCursor.css';

const MovingCursor = () => {
	const initializeCursor = () => {
		const cursorElement = document.querySelector('.moving-cursor');
		let mouseX = null;
		let mouseY = null;
		let xp = null;
		let yp = null;

		window.addEventListener('mousemove', (event) => {
			mouseX = event.clientX;
			mouseY = event.clientY;
		});

		const ok = () => {
			xp += (mouseX - xp) / 3;
			yp += (mouseY - yp) / 3;
			cursorElement.style.top = yp + 'px';
			cursorElement.style.left = xp + 'px';

			window.requestAnimationFrame(ok);
		};

		window.requestAnimationFrame(ok);
	};
	useEffect(() => {
		initializeCursor();
	}, []);
	return (
		<div className="moving-cursor">
			<p>Sprawdź</p>
		</div>
	);
};

export default MovingCursor;
